import { useMemo } from "react";
import { useLang } from "@/lib/lang";
import { useCountries } from "@/hooks/queries";

export const STATIC_COUNTRIES = [
  { code: "JO", label_ar: "الأردن", label_en: "Jordan", default_jurisdiction: "المملكة الأردنية الهاشمية" },
  { code: "AE", label_ar: "الإمارات", label_en: "United Arab Emirates", default_jurisdiction: "دولة الإمارات العربية المتحدة" },
  { code: "SA", label_ar: "السعودية", label_en: "Saudi Arabia", default_jurisdiction: "المملكة العربية السعودية" },
  { code: "KW", label_ar: "الكويت", label_en: "Kuwait", default_jurisdiction: "دولة الكويت" },
  { code: "BH", label_ar: "البحرين", label_en: "Bahrain", default_jurisdiction: "مملكة البحرين" },
  { code: "OM", label_ar: "عُمان", label_en: "Oman", default_jurisdiction: "سلطنة عُمان" },
  { code: "QA", label_ar: "قطر", label_en: "Qatar", default_jurisdiction: "دولة قطر" },
];

export function countryLabel(country, lang) {
  if (!country) return "";
  return lang === "ar" ? country.label_ar : country.label_en;
}

export function findCountry(countries, code) {
  return countries.find((c) => c.code === code) || STATIC_COUNTRIES.find((c) => c.code === code);
}

export default function CountrySelect({
  value,
  onChange,
  disabled = false,
  className = "",
  id,
  "data-testid": testId = "country-select",
  useApi = true,
}) {
  const { lang } = useLang();
  const { data } = useCountries({ enabled: useApi });

  const options = useMemo(
    () => (data?.countries?.length ? data.countries : STATIC_COUNTRIES),
    [data?.countries],
  );

  return (
    <select
      id={id}
      data-testid={testId}
      value={value || "JO"}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      className={[
        "w-full h-10 px-3 text-sm border border-slate-300 bg-white text-slate-900 outline-none",
        "focus-visible:ring-1 focus-visible:ring-slate-900 rounded-none",
        className,
      ].join(" ")}
    >
      {options.map((c) => (
        <option key={c.code} value={c.code}>
          {countryLabel(c, lang)}
        </option>
      ))}
    </select>
  );
}
